import { Button } from "@mantine/core";
import { Content, TDocumentDefinitions } from "pdfmake/interfaces";
import React from "react";
import pdfMake from "pdfmake/build/pdfmake";

interface PoLabelProps {
    poNo: string
}
export const PoLabel: React.FC<PoLabelProps> = ({ poNo }) => {
    const handlePoPrint = () => {
        try{   
            generatePDF(poNo);
        } catch (error) {
            console.log('Error in handlePoPrint:', error);
            alert('Error in Print Po Label. Please try again.');
        }
    }
    const generatePDF = (poNo: string) => {
        let contentData: Content[] = [];

        for (let i = 0; i < 4; i++) {
            contentData.push({
                table: {
                    widths: [400, '*'],
                    heights: [160],
                    body: [
                        [
                            {
                                text: poNo,
                                fontSize: 35,
                                alignment: 'left',
                                bold: true,
                                border: [false, true, false, true],
                                margin: [0, 25, 0, 0],
                                background:'#ffe927'
                            },
                            {
                                text: `Date:${new Date().toLocaleDateString()}`,
                                fontSize: 14,
                                alignment: 'center',
                                border: [false, true, false, true],
                                margin: [0, 20, 0, 0]
                            }
                        ]
                    ]
                },
                layout: {
                    defaultBorder: false,
                },

            });
        }
        const docDefinition: TDocumentDefinitions = {
            content: contentData,
            pageSize: 'LETTER',
            pageOrientation: 'portrait',
        };

        pdfMake.createPdf(docDefinition).open();
    };
    return (
        <div>
            <Button onClick={handlePoPrint}>Print PO Label</Button>
        </div>
    );
};

export default PoLabel;